import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { CustomerSurveyTypeStampDto } from "interfaces/Mueller.Business.Models";

export interface EditStampProps {
  onSave: (stamp: CustomerSurveyTypeStampDto) => void;
  onCancel: () => void;
  stamp: CustomerSurveyTypeStampDto;
}

const AddEditStamp = (props: EditStampProps) => {
  const [stamp, setStamp] = useState(props.stamp);
  const [stampTouched, setStampTouched] = useState(false);
  const [sortTouched, setSortTouched] = useState(false);

  const stampError = stampTouched && !stamp.text?.trim();
  const sortError = sortTouched && (stamp.sortOrder === null || stamp.sortOrder === undefined || isNaN(stamp.sortOrder));

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => setStamp({ ...stamp, text: e.target.value });
  const onSortChange = (e: React.ChangeEvent<HTMLInputElement>) => setStamp({ ...stamp, sortOrder: Number(e.target.value) });

  const handleSave = () => {
    setStampTouched(true);
    setSortTouched(true);
    if (stamp.text?.trim() && stamp.sortOrder !== null && stamp.sortOrder !== undefined && !isNaN(stamp.sortOrder)) {
      props.onSave(stamp);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, minWidth: 300 }}>
      <TextField
        label="Stamp"
        required
        error={stampError}
        helperText={stampError ? "This cannot be empty" : ""}
        onChange={onTextChange}
        onBlur={() => setStampTouched(true)}
        value={stamp.text}
        variant="standard"
        fullWidth
      />
      <TextField
        label="Sort"
        required
        type="number"
        inputProps={{ min: 0, max: 9999 }}
        error={sortError}
        helperText={sortError ? "This cannot be empty" : ""}
        onChange={onSortChange}
        onBlur={() => setSortTouched(true)}
        value={stamp.sortOrder}
        variant="standard"
        fullWidth
      />
      <div className="flex-row-between" style={{ marginTop: 8 }}>
        <Button onClick={handleSave}>Save</Button>
        <Button onClick={props.onCancel}>Cancel</Button>
      </div>
    </div>
  );
};

export default AddEditStamp;
